import { createConfirmation } from 'react-confirm'
import ConfirmDeleteDialog from '../components/ConfirmDeleteDialog'

const confirm = createConfirmation(ConfirmDeleteDialog)


export default function (
  confirmation: string|Object,
  options: Object = {}
): any {
  if (typeof confirmation !== 'string') {
    options = confirmation
    confirmation = ''
  }
  return confirm({ confirmation, options })
}
